import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip } from 'components';
import { OperatorService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage, Logo } from 'assets/img';
import { PhoneIcon, MailIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
}

declare var window: any;

class ModalView extends React.Component<Props> {	

	state = {
		item: this.props.item
	}

	viewURL = (e: any, url: string) => {
		if (window.webkit && window.webkit.messageHandlers) {
			e.preventDefault();
			const message = 'open_url';
			const sendToNative = {
				message,
				url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	}
	
	render() {
		return (
			<div id="modal-view-operator">
				<div className="row">
					<div className="col-md-12 text-center">
						<img src={ Logo } className="logo" />
						{/*
						// @ts-ignore */}
						<img className={ `selected-image ${ (this.state.item.photo) ? '' : 'inactive' }` } src={ (this.props.item?.photo ? (Constants.BASE_STORAGE + this.props.item?.photo) : WhiteImage) } />
					</div>
					<div className="col-md-6">
						<p className="label">Nombre</p>
						<p className="name">{ this.state.item?.full_name }</p>
					</div>
					<div className="col-md-6">
						<p className="label">Cédula</p>
						<p className="name">{ this.state.item?.full_document }</p>
					</div>
					<div className="col-md-6">
						<p className="label">Teléfono</p>
						<p className="name">
							<img src={ PhoneIcon } />
							{ this.state.item?.phone }
						</p>
					</div>
					<div className="col-md-6">
						<p className="label">Dirección</p>
						<p className="name">{ this.state.item?.address }</p>
					</div>
					<div className="col-md-6">
						<p className="label">Persona de contacto</p>
						<p className="name">{ this.state.item?.contact_person }</p>
					</div>
					<div className="col-md-12">
						<h3>Documentos</h3>
					</div>
					<div className="col-md-6">
						{
							this.state.item?.document_photo != null && (
								<a onClick={ (e: any) => this.viewURL(e,Constants.BASE_STORAGE + this.state.item?.document_photo) } href={ Constants.BASE_STORAGE + this.state.item?.document_photo } target="_blank">
									<button className="btn btn-blue">
										Cédula de identidad
									</button>
								</a>
							)
						}
					</div>
					<div className="col-md-6">
						{
							this.state.item?.work_experience != null && (
								<a onClick={ (e: any) => this.viewURL(e,Constants.BASE_STORAGE + this.state.item?.work_experience) } href={ Constants.BASE_STORAGE + this.state.item?.work_experience } target="_blank">
									<button className="btn btn-blue">
										Experiencia laboral
									</button>
								</a>
							)
						}
					</div>
					<div className="col-md-12">
						<h3>Tipo de servicio que presta</h3>
						{
							this.state.item?.services?.map((item: any) => {
								return (
									<p className="service">{ item?.service?.name }</p>
								)
							})
						}
					</div>
				</div>
			</div>
		)
	}
}

export default ModalView;